import { checkEnvironment } from '@saviynt/common';

const getEndpointsDetailsApiUrl = (endpointKey) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/endpoints/${endpointKey}`;
};

export default getEndpointsDetailsApiUrl;
